import { useUserInfoQuery } from '../apps/dashboard/__generated__/graphql';

export type ServerFeatureName =
  | 'Absences'
  | 'Announcements'
  | 'Assessments'
  | 'Certificates'
  | 'Cheers'
  | 'Corporate_Documents'
  | 'Directory'
  | 'Expenses'
  | 'Goals'
  | 'Home_Absent_Today'
  | 'Home_Birthdays_Card'
  | 'Home_New_Hires_Card'
  | 'Org_Chart'
  | 'Personal_Data'
  | 'Personal_Documents'
  | 'Private_Notes'
  | 'Projects'
  | 'Recruiting'
  | 'Shift_Planner'
  | 'Flair_Scheduler'
  | 'Skills'
  | 'Surveys'
  | 'Time_Tracking'
  | 'Ticketing'
  | 'Workflows'
  | 'HR_HelpDesk'
  | 'Inventory'
  | 'Anniversaries'
  | 'Public_Holidays'
  | 'Employee_Bank_Details'
  | 'Employee_Salaries'
  | 'Employee_Workload_Details'
  | 'Manager_Certificates'
  | 'Analytics'
  | 'Approval_Processes'
  | 'Learning'
  | 'People_Tab'
  | 'Request_Forms'
  | 'Time_Balance';

export const useServerFeature = (featureName: ServerFeatureName) => {
  const userInfo = useUserInfoQuery();
  const hubFeatures = userInfo.data?.employeeHubFeatures;

  return isFeatureVisible(featureName, hubFeatures);
};

export const useServerFeatures = () => {
  const userInfo = useUserInfoQuery();
  const hubFeatures = userInfo.data?.employeeHubFeatures;

  return (featureName: ServerFeatureName) => {
    return isFeatureVisible(featureName, hubFeatures);
  };
};

// By default feature is visible
function isFeatureVisible(featureName: string, features: any): boolean {
  const hideFeatureFieldName = createHideFeatureFieldName(featureName);
  return !features ? true : features[hideFeatureFieldName] !== true;
}

const createHideFeatureFieldName = (featureName: string) =>
  `flair__Hide_${featureName}__c`;

export type BlockFeatureName = 'Certificate_Creation' | 'Skill_Assignment';

// By default feature is not blocked. Uses current user's hub features.
export const useBlockedFeature = (featureName: BlockFeatureName): boolean => {
  const userInfo = useUserInfoQuery();
  const hubFeatures = userInfo.data?.employeeHubFeatures;

  if (!hubFeatures) {
    return false;
  }

  const blockFieldName = `flair__Block_${featureName}__c`;
  return (hubFeatures as any)[blockFieldName] === true;
};
